import { useT } from '../context/LanguageContext';
import React, { useState } from 'react';
import { useContent } from '../context/ContentContext';
import { EditButton } from './admin/EditorShell';
import { SchemaEditor } from './admin/SchemaEditor';

const ABOUT_SCHEMA = [
  { key: 'heading', label: 'Overskrift' },
  { key: 'text1', label: 'Hovudtekst', type: 'textarea', rows: 4 },
  { key: 'text2', label: 'Tekst 2 (valfritt)', type: 'textarea', rows: 2 },
  { key: 'badge', label: 'Merkelapp nedst' },
];
const highlight = (txt) => txt.split(/(\*\*[^*]+\*\*)/g).map((part, i) => part.startsWith('**') ? <span key={i} className="text-[#ff2e2e] font-bold">{part.slice(2, -2)}</span> : part);
import { mockData } from '../mock';

const About = () => {
  const { t } = useT();
  const { content } = useContent();
  const [editing, setEditing] = useState(false);
  const about = content.about;
  return (
    <section id="om" className="relative bg-black py-24 md:py-32 overflow-hidden">
      {/* Hjeltefjorden Arena background */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${mockData.heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Blurred RW27 overlay */}
      <div
        className="absolute inset-0 opacity-40 blur-2xl scale-110"
        style={{
          backgroundImage: `url(${mockData.logoImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/85" />

      <div className="relative max-w-[1200px] mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="relative rounded-3xl overflow-hidden aspect-[16/9] shadow-2xl shadow-black/60 border border-white/10 bg-black" data-testid="about-image">
          <img
            src={mockData.logoImage}
            alt="Refuel Weekend 27 – kva skjer denne helga" loading="lazy" decoding="async"
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <p className="text-[#ff2e2e] font-bold uppercase tracking-widest mb-3 text-sm">Refuel Weekend 27</p>
          <div className="flex items-start justify-between gap-4 mb-6">
            <h3 className="text-5xl md:text-7xl font-black text-white tracking-tighter" style={{ fontFamily: "'Oktah Round', sans-serif" }}>
              {t(about?.heading || 'Kva skjer?')}
            </h3>
            <EditButton onClick={() => setEditing(true)} testId="edit-about-button" />
          </div>
          {about ? (
            <>
              <p className="text-white/85 text-lg leading-relaxed mb-4" data-testid="about-text1">{highlight(about.text1 || '')}</p>
              {about.text2 && <p className="text-white/70 leading-relaxed mb-6">{highlight(about.text2)}</p>}
            </>
          ) : (<>
          <p className="text-white/85 text-lg leading-relaxed mb-4">
            {t('2.–4. april er det på')} <span className="text-[#ff2e2e] font-bold">Rong</span> {t('det skjer!')} <span className="text-[#ff2e2e] font-bold">Thor Haavik</span> {t('talar, seminar med')} <span className="text-[#ff2e2e] font-bold">Eivind Galdal</span> {t('frå Salt, konsert med ???, masse lovsang, gøye aktivitetar, underhaldning i verdsklasse, kafé og masse meir!')}
          </p>
          <p className="text-white/70 leading-relaxed mb-6">
            {t('Sett av helga allereie no – ei helg der du kan lære og oppleve tro, fellesskap og nye vennskap.')}
          </p>
          </>)}
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full border border-[#ff2e2e]/60 bg-[#ff2e2e]/10 text-[#ff2e2e] font-bold text-sm uppercase tracking-wider">
            {t(about?.badge || mockData.event.audience)}
          </div>
        </div>
      </div>
      {editing && <SchemaEditor contentKey="about" title="Rediger «Kva skjer?»" single initial={about || { heading: 'Kva skjer?', text1: '2.–4. april er det på **Rong** det skjer! **Thor Haavik** talar, seminar med **Eivind Galdal** frå Salt, konsert med ???, masse lovsang, gøye aktivitetar, underhaldning i verdsklasse, kafé og masse meir!', text2: 'Sett av helga allereie no – ei helg der du kan lære og oppleve tro, fellesskap og nye vennskap.', badge: mockData.event.audience }} schema={ABOUT_SCHEMA} onClose={() => setEditing(false)} />}
    </section>
  );
};

export default About;
